import { render, staticRenderFns } from "./ColposcopyPendingTable.vue?vue&type=template&id=7ad0b20a&"
import script from "./ColposcopyPendingTable.vue?vue&type=script&lang=js&"
export * from "./ColposcopyPendingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports